module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('UnitConversionDialog', {
    ref: "unitConvDialog"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-card-body"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.unitConversionLists,
      "paginator": true,
      "rows": 10,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "name",
      "filterField": "name",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit From",
      "field": "unitFrom.shortName",
      "filterField": "unitFrom",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit Value",
      "field": "unitFromValue",
      "filterField": "unitFromValue",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit To",
      "field": "unitTo.shortName",
      "filterField": "unitTo",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit Value",
      "field": "unitToValue",
      "filterField": "unitToValue",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editUnitConversion(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteUnitConversion
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19004a4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/UnitConversions.vue
// module id = 2064
// module chunks = 0